import React from 'react';
import css from 'styled-jsx/css';

const DESKTOP_MAX_WIDTH = '1400px';

const cardStyles = css`
  :global(body) {
    background: white;
  }

  .main-container {
    margin: 0 auto 40px;
    padding: 24px 4%;
    max-width: 100%;
    box-sizing: border-box;
  }
  @media (min-width: ${DESKTOP_MAX_WIDTH}) {
    .main-container {
      width: ${DESKTOP_MAX_WIDTH};
    }
  }
`;
const MainContainer = ({ children }) => {
  return (
    <main className="main-container">
      {children}
      <style jsx>{cardStyles}</style>
    </main>
  );
};
export default MainContainer;
